let cachedCurrency: string;

/**
 * Gets the current currency code from the server and returns it.
 */
export default async function getCurrentCurrency() {
    if (!cachedCurrency) {
        const jsonResponse = await fetch('/api/locale/get-locale-formatting-info', {credentials: 'include'});
        const response = await jsonResponse.json();
        cachedCurrency = response.int_curr_symbol;
    }
    return cachedCurrency;
}
